/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectTaskBudgetCostsQuery } from '../../models/get-project-task-budget-costs-query';
import { GetProjectTaskBudgetCostsQueryResult } from '../../models/get-project-task-budget-costs-query-result';

export interface ApiTaskBudgetCostGetTaskBudgetCostsPost$Params {
      body?: GetProjectTaskBudgetCostsQuery
}

export function apiTaskBudgetCostGetTaskBudgetCostsPost(http: HttpClient, rootUrl: string, params?: ApiTaskBudgetCostGetTaskBudgetCostsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTaskBudgetCostsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskBudgetCostGetTaskBudgetCostsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectTaskBudgetCostsQueryResult>;
    })
  );
}

apiTaskBudgetCostGetTaskBudgetCostsPost.PATH = '/api/TaskBudgetCost/GetTaskBudgetCosts';
